<template>
  <div class="login">
    <h1>Můžete se přihlásit přes:</h1>
    <a class="pure-button pure-button-primary" href="/.auth/login/github">Github</a>
    <a class="pure-button pure-button-primary" href="/.auth/login/facebook">Facebook</a>
    <a class="pure-button pure-button-primary" href="/.auth/login/google">Google</a>
    <a class="pure-button pure-button-primary" href="/.auth/login/twitter">Twitter</a>
  </div>
</template>

<style scoped>
.pure-button{
  display: block;
  width: 20rem;
  margin-bottom: .4rem;
}
</style>>
